import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import {
    GridSimpleReadHLPure,
    ValidationCodePure,
    ButtonHLPure
} from '../../pures'

/**
 * @function FirstStep
 * @description Primer paso del flujo de firma múltiple. Muestra la lista de solicitudes pendientes,
 * el total de solicitudes a firmar y el campo para ingresar el NIP de firma base.
 * @param {Object} props - Props del componente
 * @param {Array} props.volumeSigns - Lista de solicitudes de firma por volumen
 * @param {string} props.nip - NIP de firma base ingresado
 * @param {Function} props.setNip - Función para actualizar el NIP
 * @param {Function} props.showVolumeDialog - Función para mostrar/ocultar el diálogo de firma por volumen
 * @param {Function} props.setVerifiedNip - Función para verificar el NIP ingresado
 * @returns {JSX.Element} Componente del primer paso de firma múltiple
 */
const FirstStep = (props) => {
    const { t } = useTranslation()
    const [selectedItem, setSelectedItem] = useState({})
    /** @type {Array} */
    const limitedVolumeSigns = props.volumeSigns.slice(0, +process.env.REACT_APP_QUANTITY_SIGNATURES)

    return (
        <>
            <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className='signatureReceivePanel-container-volumeSign'
            >
                <GridSimpleReadHLPure
                    customClassGrid='signatureReceivePanel-customGrid'
                    dataGrid={limitedVolumeSigns}
                    skip={0}
                    take={limitedVolumeSigns.length}
                    pageableGrid={false}
                    titleRow1={'Solicitud'}
                    fieldRow1={'name'}
                    fieldSubtitle={'limitDate'}
                    textSubtitle={'subText'}
                    column2Status={window.innerWidth > 900}
                    fieldRow2={'numDocuments'}
                    titleRow2={'Cantidad documentos'}
                    styleCol2={'signatureReceivePanel-col-2'}
                    styleHeader2={'signatureReceivePanel-header-2'}
                    columnThree={window.innerWidth > 650}
                    fieldRow3={'numSigns'}
                    titleRow3={'Cantidad firmas'}
                    styleCol3={'signatureReceivePanel-col-3'}
                    styleHeader3={'signatureReceivePanel-header-3'}
                    onSelectedItem={setSelectedItem}
                />
            </Grid>
            <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className='signatureReceivePanel-totalSigns-container-volumeSign'
            >
                {t('signatureReceivePanelView2.multipleSign.totalSignatures')} {limitedVolumeSigns.length > +process.env.REACT_APP_QUANTITY_SIGNATURES
                    ? +process.env.REACT_APP_QUANTITY_SIGNATURES
                    : limitedVolumeSigns.length}
            </Grid>
            <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className='signatureReceivePanel-inputs-container-volumeSign'
            >
                <ValidationCodePure
                    data={props.nip}
                    setData={props.setNip}
                    validationLength={4}
                    title={t('dialogAcceptSignature.enter.nip')}
                    hide
                    autoFocusNIP
                />
                <Grid
                    item
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    className='signatureReceivePanel-buttons-container-volumeSign'
                >
                    <ButtonHLPure
                        onClickBtn={() => props.showVolumeDialog(false)}
                        nameBtn={t('button.cancel')}
                    />
                    <ButtonHLPure
                        disabled={props.nip.length !== 4}
                        onClickBtn={props.setVerifiedNip}
                        nameBtn={t('button.continue')}
                        primary
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default FirstStep